export const topicsData = [
  { id: 1, label: '91视频', hot: true, count: '128.6万', desc: '最受欢迎数字系列' },
  { id: 2, label: '97视频', hot: true, count: '96.3万', desc: '经典高清专区' },
  { id: 3, label: '51视频', hot: false, count: '73.8万', desc: '热门影视合集' },
  { id: 4, label: '国产剧集', hot: true, count: '115.2万', desc: '热播剧一站看' },
  { id: 5, label: '日韩剧场', hot: false, count: '67.4万', desc: '最新番剧更新' },
  { id: 6, label: '欧美大片', hot: false, count: '52.1万', desc: '好莱坞精选' },
  { id: 7, label: '动漫番剧', hot: true, count: '89.7万', desc: '二次元聚集地' },
  { id: 8, label: '综艺娱乐', hot: false, count: '44.5万', desc: '综艺一网打尽' },
  { id: 9, label: '纪录片', hot: false, count: '31.2万', desc: '深度纪实精品' },
];

export const faqData = [
  { id: 1, q: '神马视频需要注册才能观看吗？', a: '完全不需要！神马视频所有91视频、97视频、51视频等数字系列影视内容全部免费在线观看，无需注册、无需登录，打开即看，真正实现零门槛观影体验。' },
  { id: 2, q: '观看视频会卡顿缓冲吗？', a: '我们采用先进的CDN加速技术和智能码率自适应方案，确保91在线视频、高清影视等内容流畅播放不缓冲。即使用户在网络环境一般的情况下，也能获得稳定流畅的观看体验。' },
  { id: 3, q: '支持哪些设备在线观看？', a: '神马视频全面支持电脑、平板、手机等各类设备，自适应屏幕尺寸。无论是在家用电脑追91视频，还是通勤时用手机看97视频、51视频，都能享受高清流畅的观影体验。' },
  { id: 4, q: '视频内容多久更新一次？', a: '我们保持每日更新节奏，热门电视剧、电影、综艺、动漫等内容第一时间上线。91在线视频系列资源每日增量更新，确保用户始终能看到最新、最全的高清影视大全内容。' },
];

export const featuresData = [
  { id: 1, icon: 'ri-flashlight-line', title: '极速播放不缓冲', desc: '智能CDN全球加速，自适应码率技术确保91视频、97视频等高清内容秒开流畅，观影不等待。' },
  { id: 2, icon: 'ri-film-line', title: '海量资源每日更新', desc: '涵盖91在线视频、51视频等全系列数字视频资源，电视剧、电影、动漫一应俱全，每日持续扩充。' },
  { id: 3, icon: 'ri-hd-line', title: '高清画质流畅体验', desc: '多清晰度可选，从标清到超高清满足不同网络环境，让51视频高清影视大全内容呈现最佳效果。' },
  { id: 4, icon: 'ri-smartphone-line', title: '多端同步随时随地', desc: 'PC、平板、手机全端适配，无论是在家还是在外，神马视频让你随时随地免费在线观看精彩内容。' },
];

export const commentsData = [
  { id: 1, name: '影视爱好者小王', avatar: '王', text: '找了好久91视频的资源，终于在神马视频这里找到了全集！播放流畅不卡顿，画质清晰，简直是看剧神器，已经推荐给身边所有朋友了。', time: '2天前' },
  { id: 2, name: '追剧达人小李', avatar: '李', text: '97视频和51视频的资源太全了，更新速度也快。之前用别的平台老是缓冲，神马视频完全不会，高清流畅这点真的绝了。', time: '5天前' },
  { id: 3, name: '动漫迷小张', avatar: '张', text: '作为资深二次元，神马视频的动漫番剧资源让我惊喜。91在线视频的分类清晰，找片方便，最重要的是完全免费不用注册！', time: '1周前' },
  { id: 4, name: '上班族老陈', avatar: '陈', text: '通勤路上用手机看51视频高清影视大全的电视剧，画质清晰还不费流量。下班回家换电脑接着看，多端同步太方便了。', time: '2周前' },
];

export const aboutData = {
  title: '关于神马视频',
  content: '神马视频是一个专注于提供91视频、91在线视频、97视频、51视频等数字系列视频资源的高清影视大全平台。我们致力于为全国用户提供免费在线观看服务，涵盖电视剧、电影、综艺、动漫、纪录片等全品类内容。凭借先进的视频播放技术和海量正版资源，神马视频已成为数千万用户首选的在线视频网站之一。不缓冲、不卡顿、不收费，始终是我们对用户的承诺。',
};

export const indexData = [
  { id: 1, label: '91视频全集', count: '328部', imgSeq: 'index-91video', query: 'Professional cinematic movie collection collage with film reels and vintage cinema aesthetic, warm amber lighting, dark theater background, artistic composition, editorial style photography with soft shadows and rich textures' },
  { id: 2, label: '97视频专区', count: '256部', imgSeq: 'index-97video', query: 'Modern digital media library with sleek interface design elements, glowing screens displaying film thumbnails, dark sophisticated atmosphere with warm accent lights, high-end editorial photography' },
  { id: 3, label: '51视频合集', count: '189部', imgSeq: 'index-51video', query: 'Abstract geometric composition of media player symbols and film elements floating in dark space, warm golden particles, cinematic atmosphere, modern minimalist design aesthetic with soft lighting' },
  { id: 4, label: '热播电视剧', count: '412部', imgSeq: 'index-tvshows', query: 'Cozy living room scene with large TV screen displaying vibrant colors, warm ambient lighting, comfortable modern interior, cinematic wide shot, editorial interior photography style' },
  { id: 5, label: '最新电影', count: '537部', imgSeq: 'index-movies', query: 'Elegant cinema marquee with glowing neon letters in warm red and gold tones, dark night atmosphere, retro-modern fusion theater entrance, cinematic photography with dramatic lighting' },
  { id: 6, label: '动漫番剧库', count: '294部', imgSeq: 'index-anime', query: 'Artistic illustration style collage of colorful animation cells and manga panels, warm vibrant color palette, creative studio atmosphere, soft diffused lighting, editorial art photography' },
  { id: 7, label: '综艺娱乐汇', count: '165部', imgSeq: 'index-variety', query: 'Dynamic stage lighting and entertainment show atmosphere, colorful spotlights on dark background, warm golden and amber tones, concert and performance energy, editorial event photography' },
];

export const appData = {
  title: '移动观影更自由',
  subtitle: '随时随地看高清',
  desc: '神马视频移动端适配完美，无需下载APP，手机浏览器直接访问即可畅享91视频、97视频、51视频等全部高清影视资源。自适应屏幕、智能码率调节，流量和Wi-Fi环境下均能获得流畅观影体验。',
  features: ['即开即看零等待', '自适应屏幕尺寸', '4G/Wi-Fi智能切换', '手势操控更便捷'],
};

export const carouselData = [
  { id: 1, title: '91视频 · 数字系列全集上线', desc: '最受欢迎的数字系列视频资源已全面更新，涵盖91在线视频全部集数，高清画质流畅播放，一次看过瘾。', tag: '热门推荐', imgSeq: 'carousel-01' },
  { id: 2, title: '97视频 · 经典高清专区', desc: '97视频经典内容重新整理上线，优化播放体验。精选热门剧集、电影高清资源，画质升级不加价，永久免费。', tag: '最新上线', imgSeq: 'carousel-02' },
  { id: 3, title: '51视频 · 高清影视大全', desc: '51视频高清影视大全全面整合，电视剧、电影、综艺一网打尽。智能推荐算法帮你发现更多精彩内容。', tag: '编辑精选', imgSeq: 'carousel-03' },
  { id: 4, title: '追剧日历 · 每日更新提醒', desc: '热门电视剧追剧日历已上线，不再错过任何更新。91视频、97视频、51视频最新剧集第一时间推送。', tag: '追剧必备', imgSeq: 'carousel-04' },
];

export const contactData = {
  title: '联系我们',
  subtitle: '资源投稿 · 问题反馈 · 合作洽谈',
  desc: '如果您有优质视频资源推荐、使用问题反馈或商务合作意向，欢迎通过以下方式与我们联系。神马视频持续优化服务，期待您的宝贵意见。',
  email: 'contact@shenmavideo.com',
  wechat: 'shenmavideo',
  tips: ['资源推荐请附详细说明', '问题反馈请描述具体场景', '商务合作请注明来意'],
};

export const cardsData = [
  { id: 1, title: '91视频 · 热门系列', desc: '最全的91在线视频数字系列资源，高清无广告流畅播放，全集持续更新中。', icon: 'ri-fire-line', color: 'primary' },
  { id: 2, title: '97视频 · 经典回忆', desc: '97视频经典内容精华版，重温那些年追过的热门影视剧集。', icon: 'ri-time-line', color: 'accent' },
  { id: 3, title: '51视频 · 影视大全', desc: '51视频高清影视大全专区，电视剧电影综艺全覆盖，每日更新。', icon: 'ri-movie-line', color: 'primary' },
  { id: 4, title: '热播剧集追踪', desc: '当前最热门的电视剧合集，同步卫视更新进度，追剧不落伍。', icon: 'ri-tv-line', color: 'accent' },
  { id: 5, title: '院线大片速递', desc: '最新国内外院线电影高清资源，足不出户看遍全球热门大片。', icon: 'ri-clapperboard-line', color: 'primary' },
  { id: 6, title: '综艺娱乐精选', desc: '热门综艺、脱口秀、真人秀一网打尽，轻松解压快乐每一天。', icon: 'ri-emotion-happy-line', color: 'accent' },
  { id: 7, title: '动漫番剧天堂', desc: '日漫国漫新番旧作全覆盖，二次元爱好者的专属观影空间。', icon: 'ri-ghost-line', color: 'primary' },
];

export const rankingData = [
  { id: 1, rank: 1, title: '91视频全集系列', views: '1286万', change: 'up', tag: '爆款' },
  { id: 2, rank: 2, title: '最新热播电视剧', views: '963万', change: 'up', tag: '热播' },
  { id: 3, rank: 3, title: '97视频高清专区', views: '821万', change: 'down', tag: '经典' },
  { id: 4, rank: 4, title: '51视频影视大全', views: '738万', change: 'up', tag: '推荐' },
  { id: 5, rank: 5, title: '热门综艺合辑', views: '562万', change: 'up', tag: '新番' },
  { id: 6, rank: 6, title: '欧美大片精选', views: '445万', change: 'down', tag: '精选' },
];

export const updatesData = [
  { id: 1, tag: '更新', title: '91视频系列第128集上线', time: '2小时前' },
  { id: 2, tag: '新增', title: '热门韩剧《迷雾追踪》全集', time: '5小时前' },
  { id: 3, tag: '优化', title: '播放器升级，4K画质支持', time: '1天前' },
  { id: 4, tag: '更新', title: '97视频经典剧场新增30部', time: '1天前' },
  { id: 5, tag: '推荐', title: '51视频影视大全首页改版', time: '2天前' },
  { id: 6, tag: '新增', title: '国产悬疑剧《暗夜行者》上线', time: '2天前' },
  { id: 7, tag: '更新', title: '动漫新番《星辰变》第六季', time: '3天前' },
  { id: 8, tag: '公告', title: 'CDN节点扩容，播放更流畅', time: '4天前' },
  { id: 9, tag: '新增', title: '纪录片《地球脉动III》上线', time: '5天前' },
];

export const mediaData = [
  { id: 1, title: '91视频 · 热播精选', duration: '45:32', views: '128万', imgSeq: 'media-01' },
  { id: 2, title: '97视频 · 经典回顾', duration: '38:15', views: '96万', imgSeq: 'media-02' },
  { id: 3, title: '51视频 · 精彩片段', duration: '52:08', views: '83万', imgSeq: 'media-03' },
  { id: 4, title: '高清影视 · 独家推荐', duration: '41:20', views: '67万', imgSeq: 'media-04' },
];